
export enum InvoiceRequirementTypeCd {
	DEFAULT_TARIFF_RULE = 'DefaultTariffRule',
	PALLET_GROSS_WEIGHT_RULE = 'PalletGrossWeightRule',
	PALLET_NET_WEIGHT_RULE = 'PalletNetWeightRule',
	REQUIRED_TARIFF_RULE = 'RequiredTariffRule',
	THREE_PARTY_MATCH_RULE = 'ThreePartyMatchRule',
	UNIVERSAL_CTS_599_TARIFF_RULE = 'UniversalCTS599TariffRule'}

